export default __webpack_public_path__ + "static/sweepstakes-grand-2-06eccd756d62f91008ad00e9fb3e31f9.jpg";